import React, { Component, Fragment } from 'react';
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle, } from 'react-accessible-accordion';
// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';
import $ from 'jquery'
import '../../../assets/css/accordion-arrow-fancy.css'
import { get } from "../../../server/actionsParent";
import { MONTH } from "../../../server/constants";
import PDF from 'react-pdf-js'
import { BeatLoader } from 'react-spinners';
import PropTypes from "prop-types";
import MenuComponent from '../../SchoolAdmin/Menu/menuComponent';
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import { getViewMenuOptions } from '../../Misc/MenuOptions/menuOptionsActions';
import moment from 'moment'
import ReactTable from 'react-table'
import Datetime from 'react-datetime'
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import MonthCal from './monthCal';
import {
    URL_VERSION, MealTypes, MenuOrderTypes, currency_symbol,
    itemizeNotWorkingDays, regularNotWorkingDays
} from '../../../server/constants';
import { Header } from 'react-bootstrap/lib/Modal';
function menu_sort(a, b) {
    return new Date(b.monthDate) - new Date(a.monthDate)
}
class ViewMenu extends Component {
    constructor() {
        super();
        this.state = {
            student: {},
            date: new Date(),
            isParent: false,
            mealType: '',
            fireRedirect: false,
            list: [],
            pageNumber: 1,
            loading: false,
            menuObj: [],
            showCal: false
        }

    }
    componentWillMount = () => {
        const { student } = this.context.router.route.location.state;
        this.setState({
            student: student,
            mealType: (getViewMenuOptions(student.mealSchoolId || 0)[0] || '')
        }, () => {
            this.bindMenuData()
        })
    }
    bindMenuData = () => {
        const { student } = this.state;
        const url = `/mealSchoolCalendarSummaries?mealSchoolId=${student.mealSchoolId}&itemType=${this.state.mealType}&grade=${student.gradeName}&access_token=`;

        //const url = `/mealCalendarSummaries/search/findByBySchoolSchoolIdAndYearMonthRange?itemType=${this.state.mealType}&mealSchoolId=${student.mealSchoolId}&startYearMonth=${moment(this.state.date).format('YYYYMM')}&endYearMonth=${moment(this.state.date).format('YYYYMM')}&access_token=`
        get(url).then((response) => {
            this.setState({ loading: true });
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log("Orders of student returned", data)
            const filterData = data || [];
            filterData.forEach(order => {
                let month = order.yearMonth.slice(-2);
                let year = order.yearMonth.substring(0, 4)
                order.monthYear = MONTH[month - 1] + " " + year
                order.monthDate = new Date(year, month - 1, 1)

            });
            filterData.sort(menu_sort);
            this.setState({ list: filterData, loading: false }, () => {
                /* if (filterData.length > 0 && filterData.length <= 1) {
                    this.getMenu();
                } */
            })
        })
            .catch(
                (error) => {
                    console.log('Get orderlist response', error)
                    this.setState({ list: [], loading: false });
                })
    }




    selectDate = (e) => {
        let date = new Date(e);
        this.setState({ date: new Date(e) }, () => {
            this.bindMenuData();
        });
    }
    render() {
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        const renderInput = (props, openCalendar, closeCalendar) => {
            function clear() {
                props.onChange({ target: { value: '' } });
            }

            return (
                <div>
                    <input {...props} />
                    <button className="input-group-addon" onClick={openCalendar}>
                        <i className="fa fa-calendar"></i>
                    </button>
                </div>
            );
        }
        return (
            <section className="full-width clearfix">
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container ">
                    <div className="sectionTitle">
                        <h2>
                            <div className="row">
                                <div className="col-md-3">
                                    <span>View Menus</span>
                                </div>
                                <div className="col-md-8 text-right">
                                    <MenuOptions menuOptionsList={getViewMenuOptions(this.state.student.mealSchoolId || 0)}
                                        onOptionSelect={(type) => {
                                            this.setState({ mealType: type }, () => {
                                                this.bindMenuData(this.state.studentId);
                                            })
                                        }} selectedOption={(this.state.mealType)} />
                                </div>
                                <div className="col-md-1 text-right">
                                    <button className=" btn bg-color-4" style={{ margin: '0px', color: '#ffffff' }} onClick={(e) => {
                                        e.preventDefault();
                                        let _self = this;
                                        _self.context.router.history.goBack();
                                    }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                                </div>
                            </div>
                        </h2>
                    </div>
                    <div className="row">
                    </div>
                    <div className="row">
                        <div className="panel panel-primary">
                            <div className="panel-body">
                                <ReactTable
                                    data={this.state.list}
                                    columns={[
                                        {
                                            Header: "Name",
                                            accessor: 'name',
                                        },
                                        {
                                            Header: "MONTH",
                                            style: { textAlign: 'center' },
                                            accessor: "monthYear"

                                        },
                                        {
                                            Header: "MENU PDF",
                                            accessor: "pdf",
                                            style: { textAlign: 'center' },
                                            Cell: ({ row }) => (<div>
                                                <a title="Click to Download PDF" href={row._original.pdfLink}
                                                    target='_blank'
                                                    className="fa fa-file-pdf-o fa-2x"><i /></a>
                                            </div>)
                                        }
                                    ]}
                                    defaultPageSize={5}
                                    className="-striped -highlight"
                                    {...checkboxProps}
                                    SubComponent={row => {

                                        return (<div className='row'>
                                            <div className="col-md-12">
                                                <MonthCal
                                                    menuSummaryId={row.original.id}
                                                    student={this.state.student}
                                                    mealType={this.state.mealType}
                                                    isParent={true}
                                                    //menuObj={this.state.menuObj || []}
                                                    yearMonth={row.original.yearMonth} />
                                            </div>
                                        </div>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
ViewMenu.contextTypes = {
    router: PropTypes.object.isRequired
}
export default ViewMenu;


// WEBPACK FOOTER //
// ./src/components/Parent/viewMenu/index.jsx